import { Navigate } from 'react-router-dom';
import { useTenantContext } from '@/auth/TenantContext';

/**
 * Landing target for a bare/root URL (spec 0013, AC-4): redirect to the active
 * (or first) membership's slug prefix. Only renders once the tenant gate has
 * confirmed the caller has at least one membership (a tenant-less user gets the
 * create-workspace onboarding from `RequireTenant` instead).
 */
export function RootRedirect() {
  const { tenants, activeTenantId } = useTenantContext();
  const target = tenants.find((t) => t.id === activeTenantId)?.slug ?? tenants[0]?.slug;

  if (!target) {
    return null;
  }
  return <Navigate to={`/${target}`} replace />;
}
